/**
 * Phones (WP3-PHONES, BUILD-PLAN M16): live call pop with patient context,
 * click-to-call, the call log, recordings with transcript and AI summary,
 * the missed-call worklist, Insights and extension mapping.
 */
import { defineManifest } from '@velora/contracts';
import { PHONES_CALL_ENTITY, PHONES_LIVE_ENTITY } from '@velora/contracts/phones';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'phones',
    title: 'Phones',
    version: '0.1.0',
    owner: 'WP3-PHONES',
    entitlementKey: null,
    permissions: [
      'comms.view',
      'comms.send',
      'patient.view',
      'patient.edit',
      'money.view',
      'settings.manage',
    ],
    routes: [
      {
        id: 'phones',
        path: '/phones',
        title: 'Phones',
        permission: 'comms.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
      {
        // The desktop app's always-on-top call pop window (apps/desktop). No nav entry.
        id: 'desktop-call-pop',
        path: '/desktop/call-pop',
        title: 'Call pop',
        permission: 'comms.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Phones',
        group: 'operations',
        routeId: 'phones',
        icon: 'phone',
        order: 10,
        permission: 'comms.view',
      },
    ],
    commands: [
      {
        id: 'phones.open',
        title: 'Go to Phones',
        keywords: ['calls', 'call log', 'missed calls', 'voicemail', 'recordings', 'dial'],
        routeId: 'phones',
        permission: 'comms.view',
      },
      // r18 OM-08: call analytics was only reachable as Phones > tab 5.
      {
        id: 'phones.call-analytics',
        title: 'Call analytics',
        keywords: ['calls per office', 'answer rate', 'call reasons', 'phone report', 'callvault'],
        routeId: 'phones',
        search: { tab: 'analytics' },
        permission: 'comms.view',
      },
      {
        id: 'phones.ai-review',
        title: 'AI review',
        keywords: ['ai review', 'call coaching', 'call quality', 'call insights', 'transcripts'],
        routeId: 'phones',
        search: { tab: 'ai' },
        permission: 'comms.view',
      },
    ],
    shortcuts: [{ keys: 'g f', description: 'Go to Phones', routeId: 'phones' }],
    sseEntityKeys: [PHONES_LIVE_ENTITY, PHONES_CALL_ENTITY],
    phiReadPoints: ['phones.call', 'phones.caller'],
  }),
  pages: {
    phones: () => import('./PhonesPage.js'),
    'desktop-call-pop': () => import('./DesktopCallPopPage.js'),
  },
});
